import { useState, useEffect, useRef, useLayoutEffect } from "react";

import {
    CircularProgress,
    IconButton,
    Typography,
    Tooltip
} from "@mui/material";
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef, useControls } from "react-zoom-pan-pinch";
import React from "react";
import {
    Actions,
    BestViewContainer,
    LiListThumbnails,
    ListThumbnails,
    useClasses,
} from "./MiniBestView.style";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { MinibestViewHotspots } from "./MiniBestViewImage";
import { BomItemDetails } from "../../../../../explorer/types/SpareParts/BomItemDetails";
import {
    AppIconsOpen,
    AppIconsQuad,
    AppIconsReduce,
    AppIconsZoomIn,
    AppIconsZoomOut,
} from "../../../../components/AppIcons";
import { TPartListHotSpot } from "../../../../../explorer/types/SpareParts/Assembly";
import { DRAWINGS_RESOURCES } from "../../../../configuration/Resources";
import TooltipBestView from "./TooltipBestView";
  

const MiniBestView: React.FC<{
    imageName: string;
    hotspots: TPartListHotSpot[];
    parts: BomItemDetails[];
    thumbnails: string[];
    setActiveDrawing: any;
    onSelect: any;
    maximized?: boolean | undefined;
    onClose?: any;
    expandbyWidth?: boolean;
    up:boolean; 
    
    notifyCallout?: (callout: string) => void;
    calloutNotified?: string;

    notifyCalloutBestView?: (part: string) => void;
    partNotified?: string;
    partDetailsVisible?: any;

    loadingConfig?: boolean;

    site: string;
    imageFullScreen: boolean;
    setImageFullScreen: any;
}> = ({
    imageName,
    hotspots,
    parts,
    thumbnails,
    setActiveDrawing,
    onSelect,
    maximized,
    expandbyWidth,
    up,
    notifyCallout,
    calloutNotified,
    notifyCalloutBestView,
    partNotified,
    partDetailsVisible,
    loadingConfig,
    site,
    imageFullScreen,
    setImageFullScreen,
}) => {
    const [imageState, setImageState] = useState({
        imageName: imageName,
        hotsposts: hotspots,
        parts: parts,
    });

    const { t } = useTranslation();
    useEffect(() => {
        setImageState({
            imageName: imageName,
            hotsposts: hotspots,
            parts: parts,
        });
    }, [imageName, hotspots, parts]);

    const [imageLoaded, setImageLoaded] = useState(false);
    const [testState, setTestState] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({
        width: 0,
        height: 0,
        ratio: 0,
    });
    const [parentDimensions, setParentDimensions] = useState({
        width: 0,
        height: 0,
        ratio: 0,
    });

    const [scale, seScale] = useState(0);
    const [resetDone, setResetDone] = useState(false);
    const [resetDoneVisibility, setResetDoneVisibility] = useState(false);

   const initialScale = 1;

    useEffect(() => {
        if (
            (loadingConfig === undefined || loadingConfig === false) &&
            (imageName === undefined || imageName === null || imageName === "")
        ) {
            setImageLoaded(true);
            setTestState(true);
            seScale(1);
        } else if (
            imageName !== undefined &&
            imageName !== null &&
            imageName !== ""
        ) {
            resetBestView();
        } else {
            resetBestView();
        }
    }, [imageName, loadingConfig]);

    const bvRef: any = useRef(null);
    useEffect(() => {
        if (bvRef != null && bvRef.current != null) {
            if (parentDimensions.width != 0) return;
            setParentDimensions({
                width: bvRef.current.parentElement.offsetWidth,
                height: bvRef.current.parentElement.offsetHeight,
                ratio:
                    bvRef.current.parentElement.offsetWidth /
                    bvRef.current.parentElement.offsetHeight,
            });
        }
    }, [imageLoaded]);

    useEffect(() => {
        if (
            expandbyWidth !== undefined &&
            expandbyWidth == true &&
            imageDimensions.width != 0 &&
            parentDimensions.width != 0
        ) {
            seScale(parentDimensions.width / imageDimensions.width );
        } else if (imageDimensions.width != 0 && parentDimensions.width != 0) {
            seScale(
                (parentDimensions.height / imageDimensions.height) 
            );
        }
    }, [imageDimensions, parentDimensions]);

    const state = {
        type: true,
        limitToBounds: true,
        panningEnabled: true,
        transformEnabled: true,
        pinchEnabled: true,
        limitToWrapper: false,
        disabled: false,
        dbClickEnabled: true,
        lockAxisX: false,
        lockAxisY: false,
        velocityEqualToMove: true,
        enableWheel: true,
        enableTouchPadPinch: true,
        enableVelocity: true,
        limitsOnWheel: false,
        centerContent: true,
    };

    const resetAll: any = (rest: any) => {
        if (resetDone) return <></>;

        setTimeout(() => {
            if (expandbyWidth !== undefined && expandbyWidth === true) {
                rest.resetTransform();
                //rest["setPositionX"](0, 0);
                //rest["setPositionY"](0, 0);
            }
            if (parentDimensions.ratio < imageDimensions.ratio) {
                rest.resetTransform();
                //rest["setPositionX"](0, 0);
                //rest["setPositionY"](0, 0);
            }
            setResetDone(true);
            setTimeout(function () {
                setResetDoneVisibility(true);
            }, 100);
        }, 100);
        return <></>;
    };

    const onLoad = (event: any) => {
        setImageDimensions({
            height: event.target.height,
            width: event.target.width,
            ratio: event.target.width / event.target.height,
        });
        setTimeout(() => {
            setImageLoaded(true);
            setTimeout(() => {
                setTestState(false);
                setTimeout(() => setTestState(true), 200);
            }, 1);
        }, 100);
    };

    var timeoutReference = useRef<NodeJS.Timeout>();

    useLayoutEffect(() => {
        function updateSize() {
            if (timeoutReference.current !== undefined)
                clearTimeout(timeoutReference.current);
            timeoutReference.current = setTimeout(function () {
                resetBestView();
            }, 200);
        }
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    const resetBestView = () => {
        setImageLoaded(false);
        setTestState(false);
        setImageDimensions({
            width: 0,
            height: 0,
            ratio: 0,
        });
        setParentDimensions({
            width: 0,
            height: 0,
            ratio: 0,
        });
        seScale(0);
        setResetDone(false);
        setResetDoneVisibility(false);
    };

    const handleOnClick = (event: any, th: string) => {
        setActiveDrawing(th);
    };

    const [open, setOpen] = useState<boolean>(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

      const transformWrapperRef = useRef<ReactZoomPanPinchRef>(null);
      const [isInBounds, setIsInBounds] = useState(true);

    const handlePanningStop = () => {
        if (
            transformWrapperRef.current &&
            transformWrapperRef.current.instance.wrapperComponent != null &&
            transformWrapperRef.current.instance.wrapperComponent
                .parentElement != null &&
            transformWrapperRef.current.instance.contentComponent
        ) {
            const wrapperRect =
                transformWrapperRef.current.instance.wrapperComponent.getBoundingClientRect();
            const contentRect =
                transformWrapperRef.current.instance.contentComponent.getBoundingClientRect();

            const parentWrapperRect =
                transformWrapperRef.current.instance.wrapperComponent.parentElement.getBoundingClientRect();

            let _ww = wrapperRect.width;
            let _wh = wrapperRect.height;

            let _pb = parentWrapperRect.bottom; //
            let _pt = parentWrapperRect.top; //

            let _cw = contentRect.width;
            let _ch = contentRect.height;
            let _cl = contentRect.left;
            let _cr = contentRect.right;
            let _cb = contentRect.bottom;
            let _ct = contentRect.top;

            let _x = _ch - _ct;
            const marginw = 250;
            const marginh = 100;

            const inBounds =
                marginw + _cl < _ww &&
                _cl > marginw - _ww &&
                _pb - _ct > marginh &&
                _cb - _pt> marginh;
            //&& marginh + _cb < _ch
            // Check if content is within the bounds of the wrapper
            /*            const inBounds =
                contentRect.left >= wrapperRect.left &&
                contentRect.right <= wrapperRect.right &&
                contentRect.top >= wrapperRect.top &&
                contentRect.bottom <= wrapperRect.bottom;
*/
            setIsInBounds(inBounds);

            // Recenter if out of bounds
            if (!inBounds) {
                transformWrapperRef.current.resetTransform();
                setTimeout(() => {
                    if (transformWrapperRef.current !== null)
                        transformWrapperRef.current.centerView();
                }, 201);
                // transformWrapperRef.current.resetTransform(0);
            }
        }
    };

    const classes = useClasses(  {up: up});
    const renderThumbnail = (th: string) => {
        return (
            <LiListThumbnails
                data-imagename={imageName}
                isSelected={th === imageName}
                key={`lith_${th}`}
            >
                <img
                    onClick={(event: any) => handleOnClick(event, th)}
                    src={
                        DRAWINGS_RESOURCES +
                        "/" +
                        th.substring(0, 2) +
                        "/" +
                        th +
                        ".anag.th.png"
                    }
                    key={`imth_${th}`}
                    data-imagename={th}
                />
            </LiListThumbnails>
        );
    };
    const {
        panningEnabled,
        pinchEnabled,
        dbClickEnabled,
        enableWheel,
        enableTouchPadPinch,
        enableVelocity,
    } = state;
    return (
        <BestViewContainer
            style={{
                height: maximized ? "100%" : "inherit",
            }}
        >
            {!imageLoaded || !testState || scale == 0 ? (
                <>
                    <Actions></Actions>

                    <div
                        style={{
                            flex: "1 1 auto",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div style={{ textAlign: "center" }}>
                            {/* <CircularProgress
                                variant="indeterminate"
                                color="secondary"
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    //marginLeft: "50%",
                                    //marginTop: "50%",
                                }}
                            /> */}
                            <img
                                style={{ maxHeight: 100 }}
                                src="/assets/images/savio-filoblu-small.gif"
                                alt="savio-filoblu-small.gif"
                            ></img>
                            <Typography
                                variant="h6"
                                color="primary"
                                component="div"
                            >
                                {t(
                                    "common.spareparts.bom.bestview.loadingImagePleaseWait"
                                )}
                            </Typography>
                        </div>

                        <img
                            key="drawing"
                            onLoad={onLoad}
                            src={
                                DRAWINGS_RESOURCES +
                                "/" +
                                imageState.imageName.substring(0, 2) +
                                "/" +
                                imageState.imageName +
                                ".png"
                            }
                            alt="drawing"
                            ref={bvRef}
                            style={{ display: "none" }}
                        />
                    </div>
                </>
            ) : (
                <>
                    <TransformWrapper
                        ref={transformWrapperRef}
                        initialScale={scale * initialScale}
                        initialPositionX={0}
                        initialPositionY={0}
                        zoomAnimation={{
                            disabled: false,
                        }}
                        disabled={false}
                        minScale={scale * initialScale}
                        maxScale={2}
                        centerZoomedOut={false}
                        onPanningStop={handlePanningStop}
                        limitToBounds={false}
                        panning={{
                            disabled: !panningEnabled,
                            lockAxisX: false,
                            lockAxisY: false,
                            velocityDisabled: !enableVelocity,
                        }}
                        pinch={{ disabled: !pinchEnabled }}
                        doubleClick={{ disabled: !dbClickEnabled }}
                        wheel={{
                            wheelDisabled: !enableWheel,
                            touchPadDisabled: !enableTouchPadPinch,
                            //limitsOnWheel,
                            step: 5,
                        }}
                    >
                        {({ ...rest }) => (
                            <React.Fragment>
                                {resetAll(rest)}
                                <Actions>
                                    <>
                                        {" "}
                                        <TooltipBestView
                                            placement="left"
                                            title={t("common.reset")}
                                        >
                                            <IconButton
                                                onClick={() =>
                                                    rest.resetTransform()
                                                }
                                            >
                                                <AppIconsQuad />
                                            </IconButton>
                                        </TooltipBestView>
                                        <TooltipBestView
                                            placement="left"
                                            title={t("common.zoomin")}
                                        >
                                            <IconButton
                                                onClick={() => rest.zoomIn()}
                                            >
                                                <AppIconsZoomIn />
                                            </IconButton>
                                        </TooltipBestView>
                                        <TooltipBestView
                                            placement="left"
                                            title={t("common.zoomout")}
                                        >
                                            <IconButton
                                                onClick={() => rest.zoomOut()}
                                            >
                                                <AppIconsZoomOut />
                                            </IconButton>
                                        </TooltipBestView>
                                        {imageFullScreen ? (
                                            <TooltipBestView
                                                placement="left"
                                                title={t("common.reduce")}
                                                offsetY={-10}
                                                open={open}
                                                setOpen={setOpen}
                                            >
                                                <IconButton
                                                    onClick={() => {
                                                        if (
                                                            setImageFullScreen !==
                                                            undefined
                                                        )
                                                            setImageFullScreen(
                                                                !imageFullScreen
                                                            );
                                                        rest.resetTransform();
                                                        handleTooltipClose();
                                                    }}
                                                    onBlur={handleTooltipClose}
                                                >
                                                    <AppIconsReduce />
                                                </IconButton>
                                            </TooltipBestView>
                                        ) : (
                                            <TooltipBestView
                                                placement="left"
                                                title={t("common.expand")}
                                                offsetY={-10}
                                                open={open}
                                                setOpen={setOpen}
                                            >
                                                <IconButton
                                                    onClick={() => {
                                                        if (
                                                            setImageFullScreen !==
                                                            undefined
                                                        )
                                                            setImageFullScreen(
                                                                !imageFullScreen
                                                            );
                                                        rest.resetTransform();
                                                        handleTooltipClose();
                                                    }}
                                                    onBlur={handleTooltipClose}
                                                >
                                                    <AppIconsOpen />
                                                </IconButton>
                                            </TooltipBestView>
                                        )}
                                    </>
                                </Actions>

                                <TransformComponent>
                                    <img
                                        key="drawing"
                                        width={imageDimensions.width}
                                        height={imageDimensions.height}
                                        style={{
                                            visibility: resetDone /*Visibility*/
                                                ? "visible"
                                                : "hidden",
                                        }}
                                        src={
                                            DRAWINGS_RESOURCES +
                                            "/" +
                                            imageState.imageName.substring(
                                                0,
                                                2
                                            ) +
                                            "/" +
                                            imageState.imageName +
                                            ".png"
                                        }
                                        alt="drawing"
                                        //ref={bvRef}
                                    />
                                    {resetDoneVisibility && (
                                        <MinibestViewHotspots
                                            hotspots={imageState.hotsposts}
                                            transformObject={rest}
                                            notifyCallout={notifyCallout}
                                            calloutNotified={calloutNotified}
                                            notifyCalloutBestView={
                                                notifyCalloutBestView
                                            }
                                            parentDimensions={parentDimensions}
                                            imageDimensions={imageDimensions}
                                            onSelect={onSelect}
                                            parts={imageState.parts}
                                            partDetailsVisible={
                                                partDetailsVisible
                                            }
                                        />
                                    )}
                                </TransformComponent>
                            </React.Fragment>
                        )}
                    </TransformWrapper>
                </>
            )}
            <ListThumbnails sx={classes.listThumbhUp}>
                {thumbnails.map((th, index) => {
                    return renderThumbnail(th);
                })}
            </ListThumbnails>
        </BestViewContainer>
    );
};

export default MiniBestView;
